// Session tracking helpers — landing path, form-open timestamp, step timings.
//
// All values are kept in `sessionStorage` so they persist across page navigations
// within the same tab and reset when the tab closes.

const LANDING_KEY = "capitalauto_landing";
const FORM_START_KEY = "capitalauto_form_start";
const STEP_TIMES_KEY = "capitalauto_step_times";

export function rememberLanding() {
    if (typeof window === "undefined") return;
    try {
        if (!window.sessionStorage.getItem(LANDING_KEY)) {
            window.sessionStorage.setItem(
                LANDING_KEY,
                window.location.pathname + window.location.search,
            );
        }
    } catch (_) {
        /* ignore */
    }
}

export function getLanding() {
    if (typeof window === "undefined") return "direct";
    try {
        return window.sessionStorage.getItem(LANDING_KEY) || "direct";
    } catch (_) {
        return "direct";
    }
}

export function markFormStart() {
    if (typeof window === "undefined") return;
    try {
        if (!window.sessionStorage.getItem(FORM_START_KEY)) {
            window.sessionStorage.setItem(FORM_START_KEY, String(Date.now()));
            window.sessionStorage.setItem(STEP_TIMES_KEY, JSON.stringify({}));
        }
    } catch (_) {
        /* ignore */
    }
}

export function markStepComplete(stepNumber) {
    if (typeof window === "undefined") return;
    try {
        const start = parseInt(window.sessionStorage.getItem(FORM_START_KEY) || "0", 10);
        if (!start) return;
        const raw = window.sessionStorage.getItem(STEP_TIMES_KEY) || "{}";
        const map = JSON.parse(raw);
        if (!(stepNumber in map)) {
            map[stepNumber] = Date.now() - start;
            window.sessionStorage.setItem(STEP_TIMES_KEY, JSON.stringify(map));
        }
    } catch (_) {
        /* ignore */
    }
}

export function getDurationTotalMs() {
    if (typeof window === "undefined") return 0;
    try {
        const start = parseInt(window.sessionStorage.getItem(FORM_START_KEY) || "0", 10);
        return start ? Date.now() - start : 0;
    } catch (_) {
        return 0;
    }
}

export function getStepCompletionTimes() {
    if (typeof window === "undefined") return [];
    try {
        const map = JSON.parse(window.sessionStorage.getItem(STEP_TIMES_KEY) || "{}");
        // Return an ordered array indexed by step 1..N
        const max = Math.max(0, ...Object.keys(map).map((k) => parseInt(k, 10)));
        const arr = [];
        for (let i = 1; i <= max; i += 1) {
            arr.push(map[i] || null);
        }
        return arr;
    } catch (_) {
        return [];
    }
}

export function clearSessionTracking() {
    if (typeof window === "undefined") return;
    try {
        window.sessionStorage.removeItem(FORM_START_KEY);
        window.sessionStorage.removeItem(STEP_TIMES_KEY);
    } catch (_) {
        /* ignore */
    }
}
